<template>
  <div>
      <component-nav-bar />

      <div class="container mt-5 fiscal-registration-form">
          <h2 class="text-center mb-4">Credenciamento</h2>

          <form @submit.prevent="checkCpf" class="fiscal-form">
              <!-- Campo CPF -->
              <div class="form-group">
                  <label for="cpf"></label>
                  <input
                      type="text"
                      v-model="cpf"
                      v-mask="'###.###.###-##'"
                      class="form-control cpf-input"
                      placeholder="Digite o CPF"
                      :disabled="registrationComplete || fiscalExists"
                      required
                  />
              </div>

              <!-- Botão para Verificar CPF -->
              <button
                  v-if="!fiscalExists && !formEnabled"
                  type="submit"
                  class="btn btn-primary mt-3 verify-button"
              >
                  Verificar CPF
              </button>

              <!-- Botão para Imprimir Termo -->
              <button
                  v-if="fiscalExists || registrationComplete"
                  type="button"
                  class="btn btn-success mt-3 print-button"
                  @click="printFicha"
              >
                  Imprimir Termo
              </button>
          </form>

          <!-- Formulário de Inscrição Completo -->
          <div v-if="formEnabled && !registrationComplete" class="fiscal-form-section mt-4">
            <div class="bank-info-note">
                    <ul>
                      <li>O preenchimento do formulário de credenciamento não garante a participação, pois se trata de um cadastro de interesse para trabalhar no Concurso.</li>
                      <li>Os inscritos serão selecionados de acordo com a necessidade do IBCGP.</li>
                      <li>Os selecionados serão informados do resultado da seleção e do local de atuação via e-mail e WhatsApp (<a href="tel:+556730424800">67 3042 4800</a>).</li>
                      <li>O deslocamento será de responsabilidade do selecionado, e as atividades desempenhadas não geram vínculo de emprego com o IBCGP.</li>
                      <li>A previsão de pagamento é de, no máximo, dois dias após a realização do Concurso.</li>
                      <li>Caso haja alguma inconsistência no cadastro, o pagamento poderá atrasar até que sejam comprovados os dados corretos.</li>
                    </ul>
              </div>
              <form @submit.prevent="registerFiscal">
                  <div class="row">
                      <div class="form-group col-md-6">
                          <label for="nome">Nome Completo:</label>
                          <input type="text" v-model="fiscal.nome_completo" class="form-control" required />
                      </div>
                      <div class="form-group col-md-3">
                          <label for="rg">RG:</label>
                          <input type="text" v-model="fiscal.rg" class="form-control" required />
                      </div>
                      <div class="form-group col-md-3">
                          <label for="sejusp_ssp">Órgão Emissor:</label>
                          <input type="text" v-model="fiscal.sejusp_ssp" class="form-control" required />
                      </div>
                      <div class="form-group col-md-3">
                          <label for="estado_rg">UF Órgão Emissor:</label>
                          <select v-model="fiscal.estado_rg" class="form-control" required>
                              <option disabled value="">Selecione</option>
                              <option>AC</option>
                              <option>AL</option>
                              <option>AP</option>
                              <option>AM</option>
                              <option>BA</option>
                              <option>CE</option>
                              <option>DF</option>
                              <option>ES</option>
                              <option>GO</option>
                              <option>MA</option>
                              <option>MT</option>
                              <option>MS</option>
                              <option>MG</option>
                              <option>PA</option>
                              <option>PB</option>
                              <option>PR</option>
                              <option>PE</option>
                              <option>PI</option>
                              <option>RJ</option>
                              <option>RN</option>
                              <option>RS</option>
                              <option>RO</option>
                              <option>RR</option>
                              <option>SC</option>
                              <option>SP</option>
                              <option>SE</option>
                              <option>TO</option>
                          </select>
                      </div>
                      <div class="form-group col-md-8">
                          <label for="email">Email:</label>
                          <input type="text" v-model="fiscal.email" class="form-control" required />
                      </div>
                  </div>

                  <div class="row">
                      <div class="form-group col-md-6">
                          <label for="data_nascimento">Data de Nascimento:</label>
                          <input type="date" v-model="fiscal.data_nascimento" class="form-control" required />
                      </div>
                      <div class="form-group col-md-6">
                          <label for="telefone">Telefone:</label>
                          <input type="text" v-model="fiscal.telefone" class="form-control" required />
                      </div>
                  </div>

                  <!-- Campos de Endereço Separados -->
                  <div class="row">
                      <div class="form-group col-md-6">
                          <label for="logradouro">Logradouro:</label>
                          <input type="text" v-model="fiscal.logradouro" class="form-control" required />
                      </div>
                      <div class="form-group col-md-3">
                          <label for="numero">Número:</label>
                          <input type="text" v-model="fiscal.numero" class="form-control" required />
                      </div>
                      <div class="form-group col-md-3">
                          <label for="cep">CEP:</label>
                          <input type="text" v-model="fiscal.cep" class="form-control" required />
                      </div>
                  </div>

                  <div class="row">
                      <div class="form-group col-md-6">
                          <label for="bairro">Bairro:</label>
                          <input type="text" v-model="fiscal.bairro" class="form-control" required />
                      </div>
                      <div class="form-group col-md-4">
                          <label for="cidade">Cidade:</label>
                          <input type="text" v-model="fiscal.cidade" class="form-control" required />
                      </div>
                      <div class="form-group col-md-2">
                          <label for="estado">Estado:</label>
                          <select v-model="fiscal.estado" class="form-control" required>
                              <option disabled value="">Selecione</option>
                              <option>AC</option>
                              <option>AL</option>
                              <option>AP</option>
                              <option>AM</option>
                              <option>BA</option>
                              <option>CE</option>
                              <option>DF</option>
                              <option>ES</option>
                              <option>GO</option>
                              <option>MA</option>
                              <option>MT</option>
                              <option>MS</option>
                              <option>MG</option>
                              <option>PA</option>
                              <option>PB</option>
                              <option>PR</option>
                              <option>PE</option>
                              <option>PI</option>
                              <option>RJ</option>
                              <option>RN</option>
                              <option>RS</option>
                              <option>RO</option>
                              <option>RR</option>
                              <option>SC</option>
                              <option>SP</option>
                              <option>SE</option>
                              <option>TO</option>
                          </select>
                      </div>
                  </div>

                  <strong class="bank-info-note">
                      <em>Serão aceitos apenas contas em nome do Credenciado!</em>
                  </strong>

                  <!-- Dados Bancários -->
                  <div class="row">
                      <div class="form-group col-md-4">
                          <label for="banco">Banco:</label>
                          <select v-model="fiscal.banco" class="form-control" required>
                              <option disabled value="">Selecione o banco</option>
                              <option>Banco do Brasil</option>
                              <option>Caixa Econômica Federal</option>
                              <option>Bradesco</option>
                              <option>Itaú</option>
                              <option>Santander</option>
                              <option>Sicredi</option>
                              <option>Outro</option>
                          </select>
                      </div>
                      <div class="form-group col-md-4">
                          <label for="agencia">Agência:</label>
                          <input type="text" v-model="fiscal.agencia" class="form-control" required />
                      </div>
                      <div class="form-group col-md-4">
                          <label for="conta">Conta:</label>
                          <input type="text" v-model="fiscal.conta" class="form-control" required />
                      </div>
                  </div>
                  <div class="form-group">
                      <label for="chave_pix">Chave PIX:</label>
                      <input type="text" v-model="fiscal.chave_pix" class="form-control" />
                  </div>

                  <div class="form-group">
                      <label for="nivel_escolaridade">Nível de Escolaridade:</label>
                      <select v-model="fiscal.nivel_escolaridade" class="form-control" required>
                          <option disabled value="">Selecione o nível de escolaridade</option>
                          <option>Sem instrução</option>
                          <option>Ensino fundamental incompleto</option>
                          <option>Ensino fundamental completo</option>
                          <option>Ensino médio incompleto</option>
                          <option>Ensino médio completo</option>
                          <option>Ensino superior incompleto</option>
                          <option>Ensino superior completo</option>
                          <option>Mestrado</option>
                          <option>Doutorado</option>
                      </select>
                  </div>

                  <div class="form-group">
                      <label>
                          <input type="checkbox" v-model="fiscal.declaracao_nao_participante" required />
                          Declaro, sob as penas da lei, que não estou inscrito como candidato, nem como participante, em qualquer etapa ou fase do concurso público para o qual sou credenciado.
                      </label>
                  </div>
                  <div class="form-group">
                      <label>
                          <input type="checkbox" v-model="fiscal.declaracao_sem_parentesco" required />
                          Declaro, para os devidos fins, que não tenho cônjuge, companheiro(a), filhos, pais, irmãos ou quaisquer outros parentes próximos, conforme a legislação vigente, que estejam inscritos, participando ou tenham vínculo com o concurso público em questão, seja como candidatos ou ocupantes de cargos relacionados à organização ou execução do concurso.
                      </label>
                  </div>
                  <div class="form-group">
                      <label>
                          <input type="checkbox" v-model="fiscal.declaracao_sem_vinculo_logistico" required />
                          Declaro que não possuo qualquer vínculo direto ou indireto com as atividades logísticas, organizacionais ou operacionais do concurso público, seja como prestador de serviços, funcionário, colaborador ou pessoa envolvida em qualquer etapa do processo, garantindo a imparcialidade e isenção no exercício de minhas funções durante o concurso.
                      </label>
                  </div>
                  <div class="form-group">
                      <label>
                          <input type="checkbox" v-model="fiscal.disponibilidade_treinamento" required />
                          Declaro, para os fins que se fizerem necessários, que estou plenamente disponível e comprometido a participar de todos os treinamentos, orientações ou capacitações designadas para o adequado desempenho das atividades a mim atribuídas no concurso público, comprometendo-me a comparecer pontualmente e cumprir as exigências estabelecidas para a correta execução das funções que me forem incumbidas.
                      </label>
                  </div>
                  <button type="submit" class="btn btn-success mt-3 submit-button">Cadastrar Fiscal</button>
              </form>
          </div>
      </div>

      <component-footer />
  </div>
</template>

<script>
import Navbar from '../structure/Navbar.vue';
import Footer from '../structure/Footer.vue';
import { mask } from 'vue-the-mask';

export default {
  data() {
      return {
          cpf: '',
          fiscalExists: false,
          formEnabled: false,
          registrationComplete: false,
          fiscal: {
              nome_completo: '',
              rg: '',
              sejusp_ssp: '',
              estado_rg: '',
              data_nascimento: '',
              logradouro: '',
              numero: '',
              bairro: '',
              cep: '',
              cidade: '',
              estado: '',
              telefone: '',
              email: '',
              banco: '',
              agencia: '',
              conta: '',
              chave_pix: '',
              nivel_escolaridade: '',
              declaracao_nao_participante: false,
              declaracao_sem_parentesco: false,
              declaracao_sem_vinculo_logistico: false,
              disponibilidade_treinamento: false,
          },
      };
  },
  directives: { mask },
  components: {
      'component-nav-bar': Navbar,
      'component-footer': Footer,
  },
  methods: {
      async checkCpf() {
          try {
              const response = await this.$axios.get(`/geral/fiscais/cpf/${this.cpf.replace(/\D/g, '')}`);
              if (response.status === 200) {
                  this.fiscalExists = true;
              }
          } catch (error) {
              if (error.response && error.response.status === 404) {
                  this.fiscalExists = false;
                  this.formEnabled = true;
              } else {
                  console.error('Erro inesperado:', error);
              }
          }
      },
      async registerFiscal() {
          try {
              const response = await this.$axios.post('/geral/fiscais', {
                  ...this.fiscal,
                  cpf: this.cpf.replace(/\D/g, ''),
              });
              if (response.status === 201) {
                  this.registrationComplete = true;
                  this.fiscalExists = true;
              }
          } catch (error) {
              console.error('Erro ao registrar o fiscal:', error);
          }
      },
      async printFicha() {
          try {
              const fiscalResponse = await this.$axios.get(`/geral/fiscais/cpf/${this.cpf.replace(/\D/g, '')}`);
              const fiscalId = fiscalResponse.data.id;
              const response = await this.$axios.get(`/geral/fiscais/${fiscalId}/termo`, { responseType: 'blob' });
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', 'termo_compromisso.pdf');
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
          } catch (error) {
              console.error('Erro ao gerar o termo:', error);
          }
      },
  },
};
</script>

<style scoped>
.fiscal-registration-form {
  max-width: 800px;
  margin: 0 auto;
  background-color: #f8f9fa;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.form-group {
  margin-bottom: 15px;
}

.form-group.col-md-6 {
  flex: 1 1 50%;
}

.form-group.col-md-4 {
  flex: 1 1 33.333%;
}

.form-group.col-md-8 {
  flex: 1 1 66.666%;
}

.cpf-input,
.form-control {
  width: 100%;
}

.verify-button,
.print-button,
.submit-button {
  width: 100%;
  max-width: 300px;
  margin-top: 15px;
  font-size: 16px;
  padding: 10px;
}

.observations {
  background-color: #e9ecef;
  padding: 15px;
  border-radius: 8px;
  margin-top: 20px;
  font-size: 14px;
  line-height: 1.6;
}

.observations ul {
  padding-left: 20px;
}

.observations li {
  margin-bottom: 10px;
}

.bank-info-note {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  margin-top: 20px;
  font-size: 14px;
  line-height: 1.6;
  text-align: left; /* Alinha o texto à esquerda */
}

.bank-info-note ul {
  padding-left: 20px;
  list-style-type: disc;
}

.bank-info-note li {
  margin-bottom: 10px;
}

</style>
